import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Banner from "../../components/common/Banner";
import axios from 'axios';
import Navigation from "../../components/common/Navigation";

class AppAccessHome extends React.Component {

  constructor(props) {
    super();
    this.state = {isOwner: false, banner: 'Application Access', applications: [{appID: 1, appName: "APP1"},
      {appID: 2, appName: "XYZ2"},{appID: 3,appName: "DLFKSD#"}]};
    this.changeBanner = this.changeBanner.bind(this);
  }

  componentDidMount() {
    //GET All APPLICATIONS HERE - MAKE GET API CALL
    axios.get(process.env.REQ_URL + "/appaccess/getApplications", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let allApplications = response.data.data;
        //parse the response and send only application names to child components
      //allApplications=["APP1","XYZ2","DLFKSD#"];
      this.setState({applications: allApplications,applicationIds: response.data.data});
    }).catch((err)=> {
    });

    axios.get(process.env.REQ_URL + "/appaccess/isOwner", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
          let owner = response.data.data;
          this.setState({isOwner: owner});
          let newOptions = [{
                text: "My Applications",
                active: true,
                url: "#/1/applicationAccess/myApplications",
                url2: "#/1/applicationAccess"
              }];

              if(this.state.isOwner){
                newOptions.push ({text: "My Owned Applications",
                  active: true,
                  url: "#/1/applicationAccess/myOwnerApplications"
                })
              }

              if(this.props.manager){
                 newOptions.push({
                  text: "My Team Applications",
                  active: true,
                  url: "#/1/applicationAccess/myTeamApplications"
                });
              }

              if(this.props.employee.vertical){
                newOptions.push({
                  text: "VH Team Applications",
                  active: true,
                  url: "#/1/applicationAccess/vhTeamApplications"
                });
              }
            this.setState({options: newOptions});
    }).catch((err)=> {
    });
  }

  componentWillReceiveProps(nextProps){
    if(this.props.manager != nextProps.manager){
      let newOptions = [{
        text: "My Applications",
        active: true,
        url: "#/1/applicationAccess/myApplications",
        url2: "#/1/applicationAccess"
      }];

      if(this.state.isOwner){
        newOptions.push ({text: "My Owned Applications",
          active: true,
          url: "#/1/applicationAccess/myOwnerApplications"
        })
      }

      if(nextProps.manager){
        newOptions.push({
          text: "My Team Applications",
          active: true,
          url: "#/1/applicationAccess/myTeamApplications"
        });
      }

      if(nextProps.employee.vertical){
        newOptions.push({
          text: "VH Team Applications",
          active: true,
          url: "#/1/applicationAccess/vhTeamApplications"
        });
      }
      this.setState({options: newOptions});
    }
  }

  changeBanner(name) {
    this.setState({banner: name});
  }

  render() {
    return (
      <div>
        <Banner name={this.state.banner}/>
        <div className="container" style={{marginLeft: '10', marginRight: '10', width: '100%'}}>
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div id="tab_content">
                  <Navigation options={this.state.options}/>
                  <div className="tab-content responsive" style={{padding: 0}}>
                    <div role="tabpanel" className="tab-panel">
                      <div className="row clearfix">
                        {this.state.loading == 0 ?
                          <LinearProgress mode="indeterminate" style={{padding: '2px', width: '100%'}}/> :
                          <label></label> }
                        <div className="inner-col-wrap inner-table-wrap ">
                          {React.cloneElement(this.props.children, {
                            empID: this.props.employee.empno,
                            reportingToName: this.props.employee.rep,
                            reportingTo: this.props.employee.reportingToEmpID,
                            verticalHead: this.props.employee.verticalHead,
                            verticalHeadName: this.props.employee.verticalHeadName,
                            applications: this.state.applications,
                            changeBanner: this.changeBanner,
                            employees: this.state.employees,
                            refresh: this.refresh,
                            remove: this.remove
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

AppAccessHome.propTypes = {};
AppAccessHome.defaultProps = {
  options: [
    {
      text: "My Applications",
      active: true,
      url: "#/1/applicationAccess/myApplications",
      url2: "#/1/applicationAccess"
    }
  ]
};

function mapStateToProps(state, ownState) {
  return {
    state: state,
    employee: state.emp[0],
    manager: state.emp[0].manager
  };

}
export default connect(mapStateToProps)(AppAccessHome);



/** WEBPACK FOOTER **
 ** ./src/feature/appAccess/AppAccessHome.js
 **/